module.exports = __webpack_public_path__ + "img/diedfish.18676b41.jpg";